var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox',{attrs:{"true-label":1,"false-label":0},on:{"change":_vm.change},model:{value:(_vm.values),callback:function ($$v) {_vm.values=$$v},expression:"values"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }